// src/Components/Admin/AdminTopbar.js
import React, { useContext } from 'react';
import { AuthContext } from '../../contextStore/AuthContext'; // adjust path if needed

export default function AdminTopbar() {
  const { user, logout } = useContext(AuthContext) || {};
  return (
    <header style={{ height: 64, display: 'flex', alignItems: 'center', padding: '0 20px', background: '#fff', borderBottom: '1px solid #eee' }}>
      <div style={{ flex: 1 }}>
        <strong>Admin Panel</strong>
      </div>
      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        {user ? <div>{user.name} ({user.email})</div> : null}
        <button onClick={() => logout && logout()} style={{ padding: '6px 10px' }}>Logout</button>
      </div>
    </header>
  );
}
